module.exports = __webpack_public_path__ + "img/disableAcc.4c14ae31.svg";